import * as React from 'react';
import {assets} from "../helpers";
import {Registration} from "./Sony/Registration";
import {News} from "./Sony/News";
import {Map} from "../components/Map";

export class Sony extends React.Component<any, any> {
    render() {
        return (
            <div className="sony">
                <div>
                    <img src={assets("sony-banner.png")} className="img-responsive" style={{width: '100%'}} />
                </div>
                <Registration />
                <News />
                <Map />
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Sony.tsx
 **/